import React from 'react';
import { ArrowRightIcon, RefreshCwIcon } from 'lucide-react';
import { Section } from '../Section';
import { InView } from '../InView';
import { SectionHeadline } from '../SectionHeadline';
import { campaignHook, campaignInsights, campaignStages, campaignTeasers, ferringQuestions, reuseBlocks } from '../../../data/deck';
export function CampaignSection() {
  return <Section id="campaign" data-id="element-295" data-mp="1ak4e4d4pgesk">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-16" data-id="element-296" data-mp="1ajcodixshba7">
        <InView data-id="element-297" data-mp="15luf1rfv0u1o">
          <SectionHeadline lead="Not one asset." follow="A campaign we keep running." size="medium" data-id="element-298" data-mp="15k9ki1tjpb3t" />
        </InView>
        <InView delay={0.1} data-id="element-299" data-mp="1jkanpnxa8umg">
          <p className="text-[14.5px] leading-[1.7] text-[var(--muted)]" data-id="element-300" data-mp="1elpw2cw3jj9m">
            An always-on rhythm: a hook brings fertility specialists in, a Snak engages them, and every answer sharpens the next
            wave.
          </p>
        </InView>
      </div>

      <InView delay={0.16} y={26} className="mt-12" data-id="element-301" data-mp="3genjft73tjn6">
        <figure className="rounded-[30px] bg-[#EFEBE2] p-4 sm:p-6" data-id="element-302" data-mp="1ja7vg4ukdihy">
          <div className="flex h-[260px] items-center gap-3 overflow-x-auto sm:h-[340px] lg:gap-5" data-id="element-303" data-mp="1j7varjxf8u17">
            <img src={campaignHook.src} alt={campaignHook.alt} className="h-full w-auto shrink-0 rounded-[18px] object-contain" data-id="element-304" data-mp="1o6q0l5tt3iut" />
            <Arrow data-id="element-305" data-mp="1y06usaxuuzz0" />
            <div className="flex h-full shrink-0 items-center gap-3" data-id="element-306" data-mp="1y0ow3lzdk4ds">
              {campaignTeasers.map(teaser => <img key={teaser.src} src={teaser.src} alt={teaser.alt} className="h-[92%] w-auto shrink-0 rounded-[18px] object-contain" data-id="element-307" data-mp="26z0yel9lsqm2" />)}
            </div>
            <Arrow data-id="element-308" data-mp="2gvnhb4idd7lg" />
            <img src={campaignInsights.src} alt={campaignInsights.alt} className="h-[72%] w-auto shrink-0 rounded-[14px] object-contain ring-1 ring-[var(--fg)]/10" data-id="element-309" data-mp="hkm3tkbwm9in" />
          </div>

          <div className="mt-5 grid gap-4 sm:grid-cols-[22fr_46fr_32fr]" data-id="element-310" data-mp="ek2gd5cppubp">
            {campaignStages.map((stage, i) => <div key={stage.name} className="border-t border-[var(--fg)]/15 pt-3" data-id="element-311" data-mp="9lhhb9975gou" data-mpi={i}>
                <span className="text-[10px] font-semibold tabular-nums tracking-[0.2em] text-[var(--fg)]/40" data-id="element-312" data-mp="ohynlm2j454j">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="ml-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-[var(--fg)]" data-id="element-313" data-mp="xgtul0dedj8w">{stage.name}</span>
                <p className="mt-1 text-[13px] leading-snug text-[var(--muted)]" data-id="element-314" data-mp="siikqpn3r8qo">{stage.detail}</p>
              </div>)}
          </div>

          <figcaption className="mt-5 flex flex-col items-center gap-2" data-id="element-315" data-mp="12824rymjx8n4">
            <span className="inline-flex items-center gap-2 rounded-full bg-[var(--brand)] px-4 py-2 text-[11.5px] font-bold text-white" data-id="element-316" data-mp="12ay49re1s5do">
              <RefreshCwIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-317" data-mp="1c7knycun0qe4" />
              Continuous loop — every answer sharpens the next hook and question
            </span>
            <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[var(--muted)]" data-id="element-318" data-mp="1zu6hkvu1sumy">
              Example screens from a live Snakker-managed campaign
            </span>
          </figcaption>
        </figure>
      </InView>

      <div className="mt-14 grid gap-10 border-t border-[var(--fg)]/10 pt-10 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:items-center lg:gap-16" data-id="element-319" data-mp="1qs5h7q3ipsh2">
        <InView delay={0.22} data-id="element-320" data-mp="1gv0tvmxxrqyo">
          <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-[var(--muted)]" data-id="element-321" data-mp="1gwc8yiwu0l53">
            We don’t start from zero every time
          </span>
          <ul className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-5" data-id="element-322" data-mp="175hc6klym35e">
            {reuseBlocks.map(block => <li key={block} className="rounded-[16px] bg-white px-4 py-4 ring-1 ring-[var(--fg)]/[0.08]" data-id="element-323" data-mp="t56jdc13aehl">
                <span className="block text-[12px] text-[var(--muted)]" data-id="element-324" data-mp="y52ml91yq1w3">Reuse</span>
                <span className="mt-0.5 block text-[17px] font-extrabold leading-tight tracking-[-0.02em] text-[var(--fg)]" data-id="element-325" data-mp="20hz3r1v2ry1o">
                  {block}
                </span>
              </li>)}
            <li className="col-span-2 rounded-[16px] border-2 border-dashed border-[var(--brand)] px-4 py-4 sm:col-span-1" data-id="element-326" data-mp="1rpdo3umqq7h2">
              <span className="block text-[12px] font-semibold text-[var(--brand)]" data-id="element-327" data-mp="1mq13zhn97ei6">Build</span>
              <span className="mt-0.5 block text-[17px] font-extrabold leading-tight tracking-[-0.02em] text-[var(--fg)]" data-id="element-328" data-mp="1hssndlhr7ij1">
                Only what’s missing
              </span>
            </li>
          </ul>
        </InView>

        <InView delay={0.3} data-id="element-329" data-mp="18rb6i0wivcta">
          <p className="text-[28px] font-extrabold leading-[1.1] tracking-[-0.03em] text-[var(--fg)] sm:text-[34px]" data-id="element-330" data-mp="13rybutzet1g5">
            More frequent support and more{' '}
            <span className="relative whitespace-nowrap" data-id="element-331" data-mp="334aryanl318h">
              brand love
              <span aria-hidden="true" className="absolute -bottom-1 left-0 h-[3px] w-full rounded-full bg-[var(--brand)]" data-id="element-332" data-mp="2y6ipwnt85yqk" />
            </span>{' '}
            — <span className="text-[var(--brand)]" data-id="element-333" data-mp="3aobnko3srlb5">at manageable cost.</span>
          </p>
        </InView>
      </div>

      <InView delay={0.26} data-id="element-334" data-mp="3fes3qfz05l17">
        <div className="mt-12 rounded-[28px] bg-[var(--fg)] p-6 sm:p-8" data-id="element-335" data-mp="3fgmpfwi3lh6c">
          <div className="flex flex-col gap-2 lg:flex-row lg:items-end lg:justify-between lg:gap-10" data-id="element-336" data-mp="3keo6kbvyr6f6">
            <div data-id="element-337" data-mp="2mrfm8k7p83er">
              <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-[var(--brand-lighter)]" data-id="element-338" data-mp="2mrxrg6cc9ryt">Over to Ferring</span>
              <h3 className="mt-2 text-[28px] font-extrabold leading-[1.05] tracking-[-0.03em] text-white sm:text-[36px]" data-id="element-339" data-mp="2rrk86prdlqcd">
                What should REKOVELLE make interactive first?
              </h3>
            </div>
          </div>
          <ol className="mt-7 grid gap-5 md:grid-cols-3" data-id="element-340" data-mp="bz4irse2ag7i">
            {ferringQuestions.map((item, i) => <li key={item.question} className="border-t border-white/15 pt-4" data-id="element-341" data-mp="fzeu7kkmhytr" data-mpi={i}>
                <span className="text-[10px] font-semibold tabular-nums text-white/40" data-id="element-342" data-mp="2d0azwbt3ru1z">{String(i + 1).padStart(2, '0')}</span>
                <p className="mt-1 text-[18px] font-extrabold leading-snug tracking-[-0.02em] text-white" data-id="element-343" data-mp="280oehf34f7i3">{item.question}</p>
                <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-344" data-mp="2m0pmrflpth7l">
                  {item.options.map(option => <li key={option} className="rounded-full bg-white/10 px-3 py-1 text-[12px] font-semibold text-white/85" data-id="element-345" data-mp="2h0l5hnczgigb">
                      {option}
                    </li>)}
                </ul>
              </li>)}
          </ol>
          <div className="mt-8 flex items-center gap-4 rounded-[20px] bg-[var(--brand)] p-5" data-id="element-346" data-mp="233embrockhqk">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/15" data-id="element-347" data-mp="1yb4sw1o0wzjj">
              <ArrowRightIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-348" data-mp="1akral2v8qf25" />
            </span>
            <div data-id="element-349" data-mp="15mppkce985o1">
              <p className="text-[19px] font-extrabold leading-tight tracking-[-0.02em] text-white" data-id="element-350" data-mp="15l68ijkrxql7">
                Bring us one REKOVELLE benefit.
              </p>
              <p className="mt-0.5 text-[13.5px] font-semibold text-[var(--brand-lighter)]" data-id="element-351" data-mp="3m24a2wl0owb1">
                We’ll develop the clinical story and campaign together — subject to Ferring medical/legal review.
              </p>
            </div>
          </div>
        </div>
      </InView>
    </Section>;
}
function Arrow() {
  return <span aria-hidden="true" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--brand)] text-white shadow-sm" data-id="element-352" data-mp="4r37je775ksq">
      <ArrowRightIcon className="h-4 w-4" data-id="element-353" data-mp="3qzm7pqtl3p3q" />
    </span>;
}